/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import { ReactNode, useEffect } from 'react'
import { Control, FieldPath, FieldValues } from 'react-hook-form'

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { addPrefixToObject, removePrefix } from '@/utils/prefixer'

import { Label } from './label'

// prettier-ignore
export interface InputProps<
  TFieldValues extends FieldValues             = FieldValues,
  TName        extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> extends
  addPrefixToObject<React.HTMLAttributes<HTMLDivElement>,        'wrapper_'>,
  addPrefixToObject<React.InputHTMLAttributes<HTMLInputElement>, 'input_'>
{
  field_control:      Control<TFieldValues>
  field_name:         TName
  field_label?:       ReactNode
  field_description?: ReactNode
  field_mask?:        (value: string) => string
  children?:          ReactNode
}

const Component = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  field_control,
  field_name,
  field_label,
  field_description,
  field_mask,
  children,
  ...otherProps
}: InputProps<TFieldValues, TName>) => {
  // prettier-ignore
  const prefixedProps = {
    wrapper: removePrefix<React.HTMLAttributes<HTMLDivElement>>        (otherProps, 'wrapper_'),
    input:   removePrefix<React.InputHTMLAttributes<HTMLInputElement>> (otherProps, 'input_'),
  }

  return (
    <FormField
      control={field_control}
      name={field_name}
      render={({ field: { onChange, value, ...field } }) => {
        useEffect(() => {
          if (!field_mask) return
          const maskedValue = field_mask(value)
          onChange(maskedValue)
        }, [field_mask])

        if ((value as any) instanceof Date) {
          value = value.toISOString().split('T')[0]
        }

        return (
          <FormItem {...prefixedProps.wrapper}>
            {field_label && <Label>{field_label}</Label>}
            <FormControl>
              <div className="flex items-center gap-2">
                <Input
                  value={value}
                  onChange={(e) => {
                    if (!field_mask) {
                      onChange(e.target.value)
                    } else {
                      const maskedValue = field_mask(e.target.value)
                      onChange(maskedValue)
                    }
                  }}
                  {...field}
                  {...prefixedProps.input}
                />
                {children}
              </div>
            </FormControl>
            {field_description && (
              <FormDescription>{field_description}</FormDescription>
            )}
            <FormMessage />
          </FormItem>
        )
      }}
    />
  )
}
Component.displayName = 'Input'

export { Component as Input }
